import { FilterBase } from "@models/base/filterBase.model";

export class PericiaFilter extends FilterBase {

  idExpediente!: number | null;
  idsTipoPericia!: number[] | null;
  idsEstadoPericia!: number[] | null;
  idTipoParteSolicitiaTarea!: number | null;
  notificado!: boolean | null;
  lugar!: string | null;
  fechaAltaDesde!: Date | null;
  fechaAltaHasta!: Date | null;
  fechaPropuestaDesde!: Date | null;
  fechaPropuestaHasta!: Date | null;
  fechaRealizadaDesde!: Date | null;
  fechaRealizadaHasta!: Date | null;
  fechaModificacionDesde!: Date | null;
  fechaModificacionHasta!: Date | null;
  fechaCedulaPresentacionDesde!: Date | null;
  fechaCedulaPresentacionHasta!: Date | null;
  fechaVencePresentacionDesde!: Date | null;
  fechaVencePresentacionHasta!: Date | null;
  fechaAceptaCargoDesde!: Date | null;
  fechaAceptaCargoHasta!: Date | null;
  fechaProponePericiaDesde!: Date | null;
  fechaProponePericiaHasta!: Date | null;
  fechaRealizaPericiaDesde!: Date | null;
  fechaRealizaPericiaHasta!: Date | null;

  constructor() {
    super()
    this.idExpediente = null;
    this.idsTipoPericia = null;
    this.idsEstadoPericia = null;
    this.idTipoParteSolicitiaTarea = null;
    this.notificado = null;
    this.lugar = null;
    this.fechaAltaDesde = null;
    this.fechaAltaHasta = null;
    this.fechaPropuestaDesde = null;
    this.fechaPropuestaHasta = null;
    this.fechaRealizadaDesde = null;
    this.fechaRealizadaHasta = null;
    this.fechaModificacionDesde = null;
    this.fechaModificacionHasta = null;
    this.fechaCedulaPresentacionDesde = null;
    this.fechaCedulaPresentacionHasta = null;
    this.fechaVencePresentacionDesde = null;
    this.fechaVencePresentacionHasta = null;
    this.fechaAceptaCargoDesde = null;
    this.fechaAceptaCargoHasta = null;
    this.fechaProponePericiaDesde = null;
    this.fechaProponePericiaHasta = null;
    this.fechaRealizaPericiaDesde = null;
    this.fechaRealizaPericiaHasta = null;
  }
}
